import { CaretRightIcon } from '@bloomfieldrobotics/canopy';
import {
  Accordion,
  AccordionSummary,
  accordionSummaryClasses,
  AccordionSummaryProps,
  styled,
  Typography,
} from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  title: string;
  key?: string;
  expanded?: boolean;
  onChange?: (event: React.SyntheticEvent, newExpanded: boolean) => void;
  defaultExpanded?: boolean;
}>;

const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary
    expandIcon={<CaretRightIcon fontSize='small' />}
    {...props}
  />
))(({ theme }) => ({
  padding: theme.spacing(2),
  flexDirection: 'row-reverse',
  [`& .${accordionSummaryClasses.expandIconWrapper}`]: {
    color: theme.vars.palette.text.secondary,
    [`&.${accordionSummaryClasses.expanded}`]: {
      transform: 'rotate(90deg)',
    },
  },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

// TODO: move into commonUI or sprouts
export const ExpandableMenu = ({ children, title, ...props }: Props) => {
  return (
    <Accordion
      slotProps={{
        transition: { unmountOnExit: true },
        root: { elevation: 0 },
      }}
      disableGutters
      sx={{
        '&::before': {
          display: 'none',
        },
      }}
      {...props}
    >
      <StyledAccordionSummary>
        <Typography variant='body2' sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
      </StyledAccordionSummary>
      {children}
    </Accordion>
  );
};
